import React, { useState, useEffect, useRef } from "react";
import Enumerable from "linq";

//material mui
import { Button } from "@mui/material";

//icons
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import SendIcon from "@mui/icons-material/Send";

//config
import { enlistaArrayCodigosMensajesIdiomas } from "../../../Actions/Generales/IdiomasAction";
import { LlavesPortales } from "../../../Configuracion/Llaves/RepositorioConfig";
import { MostrarMensaje } from "../../../Utilidades/ManejoMensajes";
import { ValidarPropiedad } from "../../../Utilidades/ValidarPropiedades";
import CarpetasAdjuntos from "../../../Configuracion/Llaves/CarpetasAdjuntos";

//state global
import { stateAdmison } from "../Context/store";

//components
import {
  DialogoMostrarMensaje,
  mostrarDialogoMostrarMensaje,
} from "../../ControlUsuario/DialogoMostrarMensaje";
import {
  DialogoCompletaPago,
  mostrarDialogoCompletaPago,
} from "../Pago/DialogoCompletaPago";
import {
  DialogoPagoPendiente,
  mostrarDialogoPagoPendiente,
} from "../Pago/DialogoPagoPendiente";
import {
  DialogoPagoEnLinea,
  mostrarDialogoPagoEnLinea,
} from "../Pago/DialogoPagoEnLinea";
import {
  DialogoPagoExitoso,
  mostrarDialogoPagoExitoso,
} from "../Pago/DialogoPagoExitoso";
import {
  DialogoPagoFallido,
  mostrarDialogoPagoFallido,
} from "../Pago/DialogoPagoFallido";

//hooks
import { useGlobalState } from "../../../Utilidades/useGlobalState";

import { MOBILE } from '../config';

//actions
import {
  requisitoAdmisionAceptado,
  ListadoRequisitosAdmisiones,
} from "../../../Actions/Admisiones/AdmisionesRequisitosAction";
import { CrearRequisitosInstitucionalesCliente } from "../../../Actions/RequisitosInstitucionales/ReqInstAction";
import { crearAdmision, EstadoAprobacionAdmision } from "../../../Actions/Admisiones/AdmisionesAction";
import { InsertarAdjuntoRequisitos } from "../../../Actions/Admisiones/AdmisionesReqAdjuntosAction";
import { SubirArchivosServidor } from "../../../Actions/Utilidades/ManejoArchivosAction";
import { obtenerInvoiceInscripcionPrograma } from "../../../Actions/Programas/ProgramasAcademicosAction";
import {
  solicitudPagoPortal,
  validaPagoEnProcesolinea,
  validarPagoInvoice,
  validaPagoEnlineaActivo,
} from "../../../Actions/Factura/FacturaAction";
import { LlavesConfiguraciones } from "../../../Configuracion/Llaves/RepositorioConfig";
import {
  guardarPagoRetorno,
  obtenerPagoRetorno,
  limpiarPagoRetorno,
  esRetornoPago,
  limpiarParamRetornoUrl,
  PARAM_PAGO_RETORNO,
} from "../../../Utilidades/PagoRetornoStorage";

//styles
import { StyleHomeFooter, StyleHome } from "../../Tool/Style";

// GUID vacio: id "sin valor" usado por el backend (admision/invoice inexistente).
const EMPTY_GUID = "00000000-0000-0000-0000-000000000000";

const HomeFooter = ({
  deviceIs = "DESKTOP",
  Credenciales = {},
  SetCredenciales = () => {},
  SetRequisitosPendientes = () => {},
  guardarCamposDinamicosProp = () => false,
  EstadoRegistro,
  SetEstadoRegistro,
  CodigoVerificado,
  CustomerId,
  RequisitosPendientes,
  SetAdmisionEstudiante,
  SetAdmisionPreExistente,
  ListaRequisitosInstitucionales: ListaRequisitosInstitucionalesProp,
}) => {
  const { etiquetas, codigoIdioma, dispatch } = useGlobalState();

  const {
    list,
    institutionalRequirementsList,
    admissionId,
    campusId,
    clasificationId,
    estadosAdmisionId,
    periodId,
    programId,
  } = stateAdmison();

  const [MensajeEnviar, setMensajeEnviar] = useState({
    TextoMostrar: "",
    FuncionAceptar: undefined,
  });

  // datos del flujo de pago en linea (invoice + pasarela)
  // admisionId: admision creada que se aprobara al confirmar el pago.
  const [DatosPago, setDatosPago] = useState({
    admisionId: EMPTY_GUID,
    invoiceId: EMPTY_GUID,
    monto: 0,
    url: "",
    datos: "",
    // true => la sede no tiene pasarela / pago en linea disponible: el modal
    // se muestra en modo informativo (sin boton de pasarela).
    sinPasarela: false,
  });

  // Admision creada en esta sesion que quedo PENDIENTE de pago (el usuario
  // cerro/cancelo el modal sin completar el pago). Se usa para que al pulsar
  // Enviar de nuevo NO se intente crear otra admision (el backend lo rechaza con
  // "el estudiante ya tiene una admision"): en su lugar se reabre el pago del
  // invoice ya existente (usp_CajInvoice_GetInscriptionAmount es idempotente).
  // Es un ref (no state) para que persista entre reintentos sin re-render y se
  // lea con el valor actual dentro de sendAdmission.
  const admisionPendientePagoRef = useRef(EMPTY_GUID);

  const FuncionRedireccionar = () => {
    window.location.href = LlavesPortales.UrlPortalEstudiantes;
  };

  const idiomaActual = (codigoIdioma || "es").toLowerCase();

  // Solicita la URL de la pasarela y abre el iframe de pago.
  // Antes valida que no exista un pago en proceso.
  const irAPagar = async () => {
    dispatch({ type: "LOAD_HOME", texto: etiquetas.CargandoModal.Et_Procesando });

    const responseProceso = await validaPagoEnProcesolinea({
      invoiceId: DatosPago.invoiceId,
      peticionUsuario: null,
    });

    if (responseProceso.status !== 200) {
      dispatch({ type: "CLOSE_LOAD_HOME" });
      mostrarErrorRespuesta(responseProceso);
      return;
    }

    // true => ya hay un pago en proceso, no enviar a pagar
    if (responseProceso.data === true) {
      dispatch({ type: "CLOSE_LOAD_HOME" });
      mostrarDialogoPagoPendiente();
      return;
    }

    // La pasarela redirige la ventana completa a urlRetorno al finalizar, lo
    // que recarga la app y pierde el estado. Se persiste la sesion + ids para
    // reconstruir el flujo (validar pago, aprobar admision, img4) al volver, y
    // se marca la urlRetorno con ?pagoRetorno=1 para detectar ese regreso.
    guardarPagoRetorno({
      credenciales: Credenciales,
      admisionId: DatosPago.admisionId,
      invoiceId: DatosPago.invoiceId,
    });

    const urlRetorno =
      LlavesConfiguraciones.rutaPublicacionCompleta +
      "/home?" +
      PARAM_PAGO_RETORNO +
      "=1";

    const responsePortal = await solicitudPagoPortal({
      invoiceId: DatosPago.invoiceId,
      urlRetorno,
      peticionUsuario: null,
    });

    dispatch({ type: "CLOSE_LOAD_HOME" });

    if (responsePortal.status === 200) {
      const { url = "", datos = "" } = { ...responsePortal.data };
      setDatosPago((prev) => ({ ...prev, url, datos }));
      mostrarDialogoPagoEnLinea();
    } else {
      mostrarErrorRespuesta(responsePortal);
    }
  };

  // Numero de intentos y espera entre ellos al validar el pago tras cerrar el
  // iframe. Mitiga el falso negativo: si el backend aun no registro el pago al
  // cerrar, se reintenta unas veces antes de rendirse.
  const PAGO_MAX_INTENTOS = 3;
  const PAGO_ESPERA_MS = 1500;

  const esperar = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  // Aprueba la admision tras un pago confirmado. La admision se creo en PENDING
  // (el SP de insercion no la auto-aprueba cuando hay costo de inscripcion);
  // aqui se pasa a APPROVED. Si la aprobacion falla NO se bloquea el exito del
  // pago (el cobro ya ocurrio): se avisa y queda para regularizar manualmente.
  // Recibe los datos por parametro para poder reusarse desde el retorno de la
  // pasarela, donde el estado de React aun no esta reconstruido.
  const aprobarAdmision = async (admisionId, companyId, userId) => {
    const response = await EstadoAprobacionAdmision({
      AdmissionId: admisionId,
      Approved: true,
      CompanyId: companyId,
      UserId: userId,
      PeticionUsuario: null,
    });

    if (response.status !== 200) {
      MostrarMensaje(dispatch, "warning", ["WarningAprobacionAdmisionPendiente"]);
    }
  };

  // Al cerrar el iframe valida si el pago se proceso (ya no esta pendiente).
  // La admision YA fue creada al pulsar Enviar; aqui solo se confirma el pago.
  //   - pago exitoso (validarPagoInvoice === true, factura cobrada en BD) =>
  //     aprueba la admision y muestra img4.
  //   - sigue pendiente tras todos los intentos (cancelo/cerro sin pagar)
  //     => no se hace nada: admision e invoice quedan para reintentar.
  //   - error de red en todos los intentos => avisa para que el usuario
  //     verifique su pago (no se asume exito ni fallo).
  const alCerrarPago = async () => {
    dispatch({
      type: "LOAD_HOME",
      texto: etiquetas.CargandoModal.Et_Procesando,
    });

    let huboError = false;

    for (let intento = 0; intento < PAGO_MAX_INTENTOS; intento++) {
      // FIX A2026-M3-16: antes se usaba validaPagoEnProcesolinea y se tomaba
      // `false` ("ya no esta en proceso") como "pago confirmado". Pero `false`
      // tambien significa "nunca hubo pago" (el usuario cerro la pasarela sin
      // pagar), por lo que la admision se aprobaba SIN cobro. Ahora se consulta
      // la senal autoritativa en BD (factura cobrada: InvCashRegisterFK NOT NULL
      // e InvStatus='P'), igual que en el retorno de la pasarela.
      const response = await validarPagoInvoice({
        invoiceId: DatosPago.invoiceId,
        peticionUsuario: null,
      });

      if (response.status === 200) {
        huboError = false;
        // true => la factura esta efectivamente cobrada.
        if (response.data === true) {
          // Pago confirmado: aprobar la admision antes de mostrar el exito.
          await aprobarAdmision(
            DatosPago.admisionId,
            Credenciales.companyId,
            Credenciales.userId
          );
          // Pago completado: ya no hay pago pendiente que reanudar.
          admisionPendientePagoRef.current = EMPTY_GUID;
          dispatch({ type: "CLOSE_LOAD_HOME" });
          mostrarDialogoPagoExitoso();
          return;
        }
        // false => aun no conciliado (o no se pago); reintentar por si la
        // conciliacion del Centro de Pagos tarda en registrar el cobro.
      } else {
        huboError = true;
      }

      // No esperar despues del ultimo intento.
      if (intento < PAGO_MAX_INTENTOS - 1) {
        await esperar(PAGO_ESPERA_MS);
      }
    }

    dispatch({ type: "CLOSE_LOAD_HOME" });

    // Si el ultimo intento fallo por red/servidor, avisar (pago indeterminado).
    if (huboError) {
      MostrarMensaje(dispatch, "warning", ["WarningPagoNoConfirmado"]);
    }
    // Si siguio en proceso sin error, no se hace nada (reintentable).
  };

  // Retorno de la pasarela: la app se recargo (redirect de ventana completa a
  // urlRetorno con ?pagoRetorno=1). El estado de React se perdio, asi que se
  // rehidrata desde localStorage la sesion + ids guardados antes de pagar y se
  // valida el pago DIRECTAMENTE en BD (validarPagoInvoice: factura cobrada),
  // sin confiar en la URL ni consultar el Centro de Pagos por CIF global. Segun
  // el resultado se muestra el modal de exito (img4) o el de pago fallido. Pase
  // lo que pase, los datos del retorno se borran (uso unico) para no re-disparar
  // en un refresh posterior; la admision e invoice quedan intactos (reintentable).
  const procesarRetornoPago = async () => {
    const datos = obtenerPagoRetorno();

    // Se consumen una sola vez: limpiar storage y marca de URL de inmediato.
    limpiarPagoRetorno();
    limpiarParamRetornoUrl();

    if (!datos || !datos.invoiceId || datos.invoiceId === EMPTY_GUID) {
      return;
    }

    // Rehidratar credenciales para que el resto del portal recupere la sesion.
    if (datos.credenciales) {
      SetCredenciales(datos.credenciales);
    }

    dispatch({
      type: "LOAD_HOME",
      texto: etiquetas.CargandoModal.Et_Procesando,
    });

    // Validar en BD si el pago de la factura se concilio (factura cobrada).
    const response = await validarPagoInvoice({
      invoiceId: datos.invoiceId,
      peticionUsuario: null,
    });

    // Pago confirmado: aprobar la admision y mostrar el modal de exito (img4).
    if (response.status === 200 && response.data === true) {
      await aprobarAdmision(
        datos.admisionId,
        datos.credenciales?.companyId,
        datos.credenciales?.userId
      );
      // Pago completado: ya no hay pago pendiente que reanudar.
      admisionPendientePagoRef.current = EMPTY_GUID;
      dispatch({ type: "CLOSE_LOAD_HOME" });
      mostrarDialogoPagoExitoso();
      return;
    }

    dispatch({ type: "CLOSE_LOAD_HOME" });

    // Pago no confirmado (false) o error: el cobro no se realizo / quedo
    // incompleto. Se muestra el modal de pago fallido; la admision e invoice
    // quedan intactos para reintentar desde el portal de estudiantes.
    mostrarDialogoPagoFallido();
  };

  // Al montar, detecta si venimos del retorno de la pasarela y lo procesa.
  // Corre una sola vez (deps vacias): procesarRetornoPago usa datos de
  // localStorage, no del estado, por lo que no necesita dependencias.
  useEffect(() => {
    if (esRetornoPago()) {
      procesarRetornoPago();
    }
  }, []);

  const mostrarErrorRespuesta = (response) => {
    if (response && response.data && response.data.errors) {
      const arrayErrores = enlistaArrayCodigosMensajesIdiomas(
        response.data.errors
      );
      MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
    } else {
      MostrarMensaje(dispatch, "error", [response ? response.statusText : ""]);
    }
  };

  // Consulta el invoice de inscripcion para la admision ya creada. El SP es
  // idempotente: si ya existe un invoice SYSINSCRIP para esta admision lo
  // devuelve (no crea otro). Por eso requiere AdmissionId + PeriodId. Si item1
  // (invoiceId) no esta vacio hay deuda y se abre el modal de pago; si esta
  // vacio no hay deuda. La admision ya fue creada antes de llamar aqui.
  // @param {string} admisionId id de la admision recien creada (o existente).
  // @returns {Promise<boolean>} true si se abrio el flujo de pago.
  const validarFlujoPago = async (admisionId, sinPasarela = false) => {
    const objInvoice = {
      CustomerId: Credenciales.customerId,
      ProgramId: programId,
      CampusId: campusId,
      CompanyId: Credenciales.companyId,
      AdmissionId: admisionId,
      PeriodId: periodId,
    };

    const response = await obtenerInvoiceInscripcionPrograma(objInvoice);

    if (response.status !== 200) {
      mostrarErrorRespuesta(response);
      return false;
    }

    const invoiceId = response.data?.item1;
    const monto = response.data?.item2;

    const invoiceVacio =
      invoiceId === undefined ||
      invoiceId === null ||
      invoiceId === "" ||
      invoiceId === EMPTY_GUID;

    if (invoiceVacio) {
      return false;
    }

    // Se guarda admisionId junto al invoice: al confirmar el pago (alCerrarPago)
    // se usa para aprobar la admision.
    setDatosPago({ admisionId, invoiceId, monto: monto || 0, url: "", datos: "", sinPasarela });
    mostrarDialogoCompletaPago();
    return true;
  };

  // Indica si el comercio/sede tiene el PAGO EN LINEA activo (contrato con
  // banco en linea y habilitado por el comercio). El flujo de pago por pasarela
  // es transversal: solo se dispara cuando esta activo. Si el endpoint responde
  // false (sin contrato o desactivado por el comercio) o falla, se considera
  // INACTIVO y el portal NO cobra: la admision se envia con el flujo normal y
  // el admin gestiona el pago en Cajas.
  const esPagoEnLineaActivo = async () => {
    const response = await validaPagoEnlineaActivo({
      companyId: Credenciales.companyId,
      campusId: campusId,
      peticionUsuario: null,
    });

    return response.status === 200 && response.data === true;
  };

  const funcionValidarEnviar = () => {
    if (RequisitosPendientes > 0)
      setMensajeEnviar({
        TextoMostrar: etiquetas.Home.Et_lblAdjuntosPendientes,
        FuncionAceptar: undefined,
      });
    else
      setMensajeEnviar({
        TextoMostrar: etiquetas.Home.Et_lblEnviarAdmisionMsg,
        FuncionAceptar: FuncionRedireccionar,
      });

    mostrarDialogoMostrarMensaje();
  };

  // Crea la admision y procesa requisitos/adjuntos. Se ejecuta SIEMPRE al
  // pulsar Enviar en una admision nueva, ANTES de cualquier cobro.
  //
  // @returns {Promise<{admisionId: string, completa: boolean}>}
  //   admisionId: id de la admision creada ("0000..." si fallo la creacion).
  //   completa: true si quedo sin adjuntos pendientes.
  // Si faltan adjuntos muestra el aviso correspondiente. Esta funcion NO
  // decide el mensaje final de exito ni el redirect: eso lo resuelve el caller
  // (sendAdmision: redirige; alCerrarPago: muestra img4).
  const procesarAdmision = async () => {
    dispatch({
      type: "LOAD_HOME",
      texto: etiquetas.CargandoModal.Et_Procesando,
    });

    let admisionCompleta = false;

    const admisionResult = await salvarAdmision();

    if (!(admisionResult === EMPTY_GUID)) {
      const objReq = { AdmissionId: admisionResult };

      const response = await ListadoRequisitosAdmisiones(objReq);

      if (response.status === 200) {
        const attachments = response.data.filter(
          (x) => x.aprFileRequired === true || x.aprAcceptRequirement === true
        );

        if (attachments.length > 0) {
          let auxArray = [];

          attachments.forEach((item) => {
            const found = list.find(
              (x) => x.aprProgramReqId === item.adrProgRequirementIdFk
            );

            if (found) {
              auxArray.push({
                requirementId: item.adrRequirementId,
                aprAcceptedByStudent: found.aprAcceptedByStudent,
                aprAcceptRequirement: found.aprAcceptRequirement,
                aprFileRequired: found.aprFileRequired,
                fileDetail: found.fileDetail,
              });
            }
          }); //fin forEach attachments

          //auxArray.forEach(async (item) => {
          for (const item of auxArray) {
            if (item.aprAcceptedByStudent) {
              await requirementAdmissionAccepted(
                item.requirementId,
                item.aprAcceptedByStudent
              );
            }

            if (item.aprFileRequired && item.fileDetail !== null) {
              await guardarDataArchivo(item.fileDetail, item.requirementId);
            }
          } //)//fin forEach auxArray

          const responseVerificaAdj = await ListadoRequisitosAdmisiones(objReq);

          const sinAdjuntos = Enumerable.from(responseVerificaAdj.data)
            .where(
              (x) =>
                x.attachments === false &&
                x.aprFileRequired === true &&
                x.isRequired === true
            )
            .toArray();

          if (sinAdjuntos.length > 0) {
            SetAdmisionEstudiante(admisionResult);
            SetAdmisionPreExistente(true);
            setMensajeEnviar({
              TextoMostrar: etiquetas.Home.Et_lblAdjuntosPendientes,
              FuncionAceptar: undefined,
            });
            mostrarDialogoMostrarMensaje();
          } else {
            admisionCompleta = true;
          }
        } else {
          SetRequisitosPendientes(0);
          admisionCompleta = true;
        }
      }
      //create the institutional requirement for this customer
      await modificarRequisitosIntitucionales(admisionResult);

    }

    dispatch({ type: "CLOSE_LOAD_HOME" });

    return { admisionId: admisionResult, completa: admisionCompleta };
  };

  const modificarRequisitosIntitucionales = async (admisionResult) => {

    const listToProcess =
      institutionalRequirementsList && institutionalRequirementsList.length > 0
        ? institutionalRequirementsList
        : ListaRequisitosInstitucionalesProp || [];

    if (listToProcess && listToProcess.length > 0) {
      const payloadReqInst = {
        CustomerId: Credenciales.customerId || CustomerId,
        AdmissionId: admisionResult,
        ListaRequisitosInstitucionales: listToProcess.map((item) => ({
          RequirementId: item.requirementId || item.RequirementId,
          IrcAcceptedByCustomer: item.ircAcceptedByCustomer,
          FileInfo: item.fileDetail || item.fileInfo || null,

        })),
        CompanyId: Credenciales.companyId,
        UserId: Credenciales.userId,
      };

      const filesToUpload = await CrearRequisitosInstitucionalesCliente(payloadReqInst);
      //console.log(filesToUpload);
      const results = filesToUpload.data.map(fu => {
        const requirement = payloadReqInst.ListaRequisitosInstitucionales.find(
          item => item.RequirementId === fu.RequirementId
        );

        return {
          IrcRequirementId: fu.IrcRequirementId,
          file: requirement.FileInfo
        };
      });
      for (const item of results) {
        await SubirArchivoReqInstServidor(item.file, item.IrcRequirementId);
      }

    }


  };

  const sendAdmission = async () => {
    // Reintento de pago: en esta sesion ya creamos una admision que quedo
    // pendiente de pago (el usuario cerro/cancelo el modal). NO recrear la
    // admision (el backend responderia "el estudiante ya tiene una admision"):
    // se reabre el pago del invoice existente.
    if (admisionPendientePagoRef.current !== EMPTY_GUID) {
      dispatch({
        type: "LOAD_HOME",
        texto: etiquetas.CargandoModal.Et_Procesando,
      });
      const pagoLineaActivo = await esPagoEnLineaActivo();
      const abrioPago = await validarFlujoPago(
        admisionPendientePagoRef.current,
        !pagoLineaActivo
      );
      dispatch({ type: "CLOSE_LOAD_HOME" });

      // Si ya no hay deuda (p.ej. el pago se completo en otra pestana), se
      // limpia el pendiente y se sigue el flujo normal de envio.
      if (!abrioPago) {
        admisionPendientePagoRef.current = EMPTY_GUID;
        setMensajeEnviar({
          TextoMostrar: etiquetas.Home.Et_lblEnviarAdmisionMsg,
          FuncionAceptar: FuncionRedireccionar,
        });
        mostrarDialogoMostrarMensaje();
      }
      return;
    }

    // Admision ya existente: el estudiante volvio a Nuevo Ingreso con una
    // admision creada antes que quedo PENDIENTE de pago (Seleccion.js ya la
    // cargo en admissionId via buscarAdmision). NO se recrea la admision (el
    // backend responde ErrorValidatingAdmission "ya tiene una admision"): se
    // consulta la inscripcion y, si sigue impaga, se abre "Completa tu pago"
    // del invoice existente para que el estudiante pueda pagarla. La admision
    // permanece PENDIENTE hasta que el pago se confirme.
    if (admissionId !== EMPTY_GUID) {
      await modificarRequisitosIntitucionales(admissionId);
      funcionValidarEnviar();
      return;
    }

    // Admision nueva: SIEMPRE se crea primero (con sus adjuntos), porque el
    // proceso de admision debe existir antes de cobrar.
    const { admisionId, completa } = await procesarAdmision();

    // Si la creacion fallo, procesarAdmision ya mostro el error.
    if (admisionId === EMPTY_GUID) {
      return;
    }

    // Si faltan adjuntos, procesarAdmision ya mostro el aviso: no se cobra.
    if (!completa) {
      return;
    }

    // Admision creada y completa. Se consulta SIEMPRE si hay inscripcion por
    // pagar (invoice SYSINSCRIP). El modal "Completa tu pago" se muestra en dos
    // modos, segun si el comercio/sede tiene el pago en linea ACTIVO:
    //   - activo   -> modal con boton "Ir a pagar" (pasarela).
    //   - inactivo -> modal informativo SIN boton de pasarela: avisa que el PIN
    //                 de inscripcion se paga en caja (antes no se mostraba nada y
    //                 la admision se enviaba como si no tuviera deuda).
    dispatch({
      type: "LOAD_HOME",
      texto: etiquetas.CargandoModal.Et_Procesando,
    });

    const pagoLineaActivo = await esPagoEnLineaActivo();

    const abrioPago = await validarFlujoPago(admisionId, !pagoLineaActivo);

    // Si se abrio el pago, recordar la admision creada: si el usuario cierra el
    // modal sin pagar y vuelve a pulsar Enviar, se reanuda el pago del invoice
    // existente en lugar de intentar crear otra admision (que el backend
    // rechazaria). Se limpia al confirmar el pago (aprobarAdmision).
    if (abrioPago) {
      admisionPendientePagoRef.current = admisionId;
    }

    dispatch({ type: "CLOSE_LOAD_HOME" });

    // Se muestra el mensaje normal de envio y redirige cuando:
    //   - el pago en linea esta inactivo (admin cobra en Cajas), o
    //   - esta activo pero no hay deuda/invoice (validarFlujoPago devolvio false).
    // Si hay deuda y el pago esta activo, validarFlujoPago ya abrio el modal.
    if (!abrioPago) {
      setMensajeEnviar({
        TextoMostrar: etiquetas.Home.Et_lblEnviarAdmisionMsg,
        FuncionAceptar: FuncionRedireccionar,
      });
      mostrarDialogoMostrarMensaje();
    }
  };


  const requirementAdmissionAccepted = async (aprRequirementIdFk, checked) => {
    const objReq = {
      requirementId: aprRequirementIdFk,
      accept: checked,
      companyId: Credenciales.companyId,
      userId: Credenciales.userId,
    };

    const response = await requisitoAdmisionAceptado(objReq);

    if (response.status === 200) {
      //MostrarMensaje(dispatch, 'success', ['updateOk']);
    } else {
      if (response.data.errors) {
        const arrayErrores = enlistaArrayCodigosMensajesIdiomas(
          response.data.errors
        );
        MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
      } else {
        MostrarMensaje(dispatch, "error", [response.statusText]);
      }
    }
  };

  // Crea la admision via backend. Devuelve SIEMPRE un Guid:
  //   - el id de la admision creada si fue exitosa.
  //   - EMPTY_GUID si la validacion de campos fallo o el request fallo.
  // Nunca devuelve undefined: el caller compara contra EMPTY_GUID.
  const salvarAdmision = async () => {
    const objetoAdmision = {
      AdmissionId: EMPTY_GUID,
      CustomerId: Credenciales.customerId,
      ProgramId: programId,
      CampusId: campusId,
      PeriodId: periodId,
      StatusId: estadosAdmisionId,
      ClassificationId: clasificationId,
      CompanyId: Credenciales.companyId,
      UserId: Credenciales.userId,
    };
    const FieldsRequired = [
      { code: "CustomerId", codeError: "WarningSelectEstudiante" },
      { code: "ProgramId", codeError: "WarningSelectPrograma" },
      { code: "PeriodId", codeError: "WarningSelectTipoPeriodo" },
      { code: "CampusId", codeError: "WarningSelectSede" },
      { code: "StatusId", codeError: "SearchFilterEstadoId" },
      { code: "ClassificationId", codeError: "SearchFilterClasf" },
    ];

    const validacionCampos = ValidarPropiedad(
      FieldsRequired,
      objetoAdmision,
      dispatch
    );

    // Validacion fallo: ValidarPropiedad ya mostro el aviso. No se llama al
    // backend y se devuelve EMPTY_GUID para que el caller corte el flujo.
    if (!validacionCampos) {
      return EMPTY_GUID;
    }

    return await crearAdmision(objetoAdmision).then((response) => {
      if (response.status === 200) {
        //si la respuesta fue existosa
        // admisionDispatch({type:'changeAdmissionId', payload:{ admissionId:response.data }});

        //MostrarMensaje(dispatch, 'success', ["ok"]);

        return response.data;
      } else {
        if (response.data.errors) {
          const arrayErrores = enlistaArrayCodigosMensajesIdiomas(
            response.data.errors
          );
          MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
        } else {
          MostrarMensaje(dispatch, "error", [response.statusText]);
        }

        return EMPTY_GUID;
      }
    });
  };

  const SubirArchivoServidor = async (file, requirementId) => {
    let resultado = false;
    const dataObject = {
      FileType: file.tipo,
      FileContent: file.contenido,
      FileSize: file.tamano,
      FileName: file.nombre,
      ObjectId: requirementId,
      FolderName: CarpetasAdjuntos.RequisitosAdmision,
      CompanyId: Credenciales.companyId,
      UserId: Credenciales.userId,
    };

    await SubirArchivosServidor(dataObject).then((response) => {
      if (response.status === 201) {
        //si la respuesta fue existosa
        resultado = true;
      } else {
        if (response.status === 401) {
          MostrarMensaje(dispatch, "error", ["ErrorFile401"]);
        } else if (response.status === 409) {
          MostrarMensaje(dispatch, "warning", ["ErrorFile409"]);
        } else if (response.status === 500) {
          MostrarMensaje(dispatch, "error", ["InternalServerError"]);
        } else if (response.data.errors) {
          const arrayErrores = enlistaArrayCodigosMensajesIdiomas(
            response.data.errors
          );
          MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
        } else {
          MostrarMensaje(dispatch, "error", [response.statusText]);
        }
      }
    });

    return resultado;
  };


  const SubirArchivoReqInstServidor = async (file, requirementId) => {
    let resultado = false;
    const dataObject = {
      FileType: file.tipo,
      FileContent: file.contenido,
      FileSize: file.tamano,
      FileName: file.nombre,
      ObjectId: requirementId,
      FolderName: CarpetasAdjuntos.RequisitosInstitucionales,
      CompanyId: Credenciales.companyId,
      UserId: Credenciales.userId,
    };

    await SubirArchivosServidor(dataObject).then((response) => {
      if (response.status === 201) {
        //si la respuesta fue existosa
        resultado = true;
      } else {
        if (response.status === 401) {
          MostrarMensaje(dispatch, "error", ["ErrorFile401"]);
        } else if (response.status === 409) {
          MostrarMensaje(dispatch, "warning", ["ErrorFile409"]);
        } else if (response.status === 500) {
          MostrarMensaje(dispatch, "error", ["InternalServerError"]);
        } else if (response.data.errors) {
          const arrayErrores = enlistaArrayCodigosMensajesIdiomas(
            response.data.errors
          );
          MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
        } else {
          MostrarMensaje(dispatch, "error", [response.statusText]);
        }
      }
    });

    return resultado;
  };

  const guardarDataArchivo = async (fileInfo, requirementId) => {
    let ProcesarSiguiente = true;

    if (ProcesarSiguiente) {
      ProcesarSiguiente = await SubirArchivoServidor(fileInfo, requirementId);
    }
    if (ProcesarSiguiente) {
      ProcesarSiguiente = await InsertarArchivo(fileInfo, requirementId);
    }
  };

  const InsertarArchivo = async (file, requirementId) => {
    let resultado = false;
    const objetoAdjunto = {
      RequirementId: requirementId,
      FileName: file.nombre,
      MimeType: file.tipo,
      CompanyId: Credenciales.companyId,
      UserId: Credenciales.userId,
    };

    const responseInsertarAdjunto = await InsertarAdjuntoRequisitos(
      objetoAdjunto
    );
    if (responseInsertarAdjunto.status === 200) {
      //si la respuesta fue existosa
      //MostrarMensaje(dispatch, 'success', ["updateOk"]);
      resultado = true;
    } else {
      if (responseInsertarAdjunto.data.errors) {
        const arrayErrores = enlistaArrayCodigosMensajesIdiomas(
          responseInsertarAdjunto.data.errors
        );
        MostrarMensaje(
          dispatch,
          responseInsertarAdjunto.data.typeError,
          arrayErrores
        );
      } else {
        MostrarMensaje(dispatch, "error", [responseInsertarAdjunto.statusText]);
      }
    }

    return resultado;
  };

  return (
    <div style={ deviceIs === MOBILE ? { display:'flex', gap:"5px", padding: "9px", marginBottom:'8px', marginTop:"0px", } : StyleHomeFooter.Container}>
      <Button
        disabled={CodigoVerificado === false || EstadoRegistro === true}
        startIcon={<ArrowBackIosNewIcon style={{ color: "#3F425D" }} />}
        style={
          EstadoRegistro === true
            ? { ...StyleHome.ButtonClean, ...{ width: deviceIs === MOBILE ? '47.5%' : 150, marginLeft: 10 } }
            : deviceIs === MOBILE ? { 
              width: deviceIs === MOBILE ? '47.5%': 150,
              color: '#3F425D',
              backgroundColor: '#1EE3CF', } : StyleHomeFooter.Button
        }
        onClick={() => {
          SetEstadoRegistro(true);
        }}
      >
        {etiquetas.General.Et_tbnAtras}
      </Button>
      <div
        style={{
          width: deviceIs === MOBILE ? '47.5%': 'initial',
          textAlign:'center',
          display:
            CodigoVerificado === false || EstadoRegistro === true
              ? "initial"
              : "none",
          margin: "0px",
          padding: "0px",
        }}
      >
        <Button
          disabled={
            CustomerId === EMPTY_GUID ||
            CodigoVerificado === false ||
            EstadoRegistro === false
          }
          endIcon={<ArrowForwardIosIcon style={{ color: "#3F425D" }} />}
          style={
            CustomerId !== EMPTY_GUID &&
            CodigoVerificado === true &&
            EstadoRegistro === true
              ? deviceIs === MOBILE ? { 
                width: deviceIs === MOBILE ? '100%': 150,
                color: '#3F425D',
                backgroundColor: '#1EE3CF', } : StyleHomeFooter.Button
              : { ...StyleHome.ButtonClean, ...{ width: deviceIs === MOBILE ? '100%' : 150, marginLeft: deviceIs === MOBILE ? 0 : 10 } }
          }
          onClick={async () => {
            const result = await guardarCamposDinamicosProp();

            if (result) {
              SetEstadoRegistro(false);
            }
          }}
        >
          {etiquetas.General.Et_tbnSiguiente}
        </Button>
      </div>
      
      { deviceIs === MOBILE ? null : <div
        style={{
          display:
            CodigoVerificado === false || EstadoRegistro === true
              ? "none"
              : "initial",
          margin: "0px",
          padding: "0px",
        }}
      >
        <Button
          startIcon={<SendIcon style={{ color: "#3F425D" }} />}
          style={StyleHomeFooter.Button}
          onClick={() => {
            sendAdmission(); /*funcionValidarEnviar()*/
          }}
        >
          {etiquetas.ToolbarButtons.Et_BtnEnviar}
        </Button>
      </div> }

      <DialogoMostrarMensaje
        deviceIs={deviceIs}
        TextoMostrar={MensajeEnviar.TextoMostrar}
        funcionAceptar={MensajeEnviar.FuncionAceptar}
      />

      <DialogoCompletaPago
        monto={DatosPago.monto}
        onIrAPagar={irAPagar}
        sinPasarela={DatosPago.sinPasarela}
        onCerrar={FuncionRedireccionar}
      />

      <DialogoPagoPendiente />

      <DialogoPagoEnLinea
        url={DatosPago.url}
        datos={DatosPago.datos}
        idioma={idiomaActual}
        onCerrar={alCerrarPago}
      />

      <DialogoPagoExitoso onContinuar={FuncionRedireccionar} />

      <DialogoPagoFallido />
    </div>
  );
};

export default HomeFooter;
